// import { debug } from 'util'
import { merge } from "lodash";

/**
 * The Store Pattern
 * actions -> mutations
 * Never mutate the store directly.
 *
 * General errors go in the header
 */

// initial state
const state = {
  general: [],
  promoCode: [],
  giftCard: [],
  timeslotPicker: [],
  cartChange: [],
  changeStore: [],
  deliveryAddress: [],
  pastPurchases: [],
  paymentMethods: [],
};

// getters
const getters = {
  timeslotErrors: state => state.timeslotPicker,
  hasTimeslotErrors: (state, getters) => !!getters.timeslotErrors.length,
  changeStoreErrors: state => state.changeStore,
  hasChangeStoreErrors: (state, getters) => !!getters.changeStoreErrors.length,
  deliveryAddressErrors: state => state.deliveryAddress,
  hasDeliveryAddressErrors: (state, getters) =>
    !!getters.deliveryAddressErrors.length
};

// actions - can be async
const actions = {
  /**
   * Error handler function to accept complex error object (add whatever you want)
   * and commit the correct error info to store with all parameters, plus more
   * @param {object} error - info about the error
   */
  HANDLE_ERROR({ COMMIT }, error) {
    // console.log('HANDLE_ERROR()', error)

    const vm = this;
    const { response, request, message, type, config, variant, data } = error;

    if (type === "paymentMethods") {
      // certain error types are for specific sections and shouldn't affect all errors
      vm.commit("errors/CLEAR_ERROR_TYPE", type);
    } else {
      vm.commit("errors/CLEAR_ERRORS");
    }

    if (response) {
      vm.commit("errors/PUSH_ERROR", {
        code: response.status,
        data,
        extraParameters: response.data.extraParameters,
        message: response.data.title || message,
        type,
        variant
      });
    } else if (request) {
      vm.commit("errors/PUSH_ERROR", {
        message: "Couldn't contact the website",
        type,
        variant
      });
      console.log(request);
    } else {
      console.log("Error", message);
      vm.commit("errors/PUSH_ERROR", { message, type, variant });
    }
    console.log(config);
  }
};

// mutations - Must be synchronous
const mutations = {
  PUSH_ERROR(state, error) {
    // console.log('~ PUSH_ERROR()', error)

    const DEFAULTS = {
      icon: "fa-exclamation-triangle",
      type: "general", // specify the location that the error should show
      message: "Unknown Error", // text or html
      id: "",
      code: "000",
      variant: "danger", // warning, info, danger
      extraParameters: {}
    };

    // merge error object with defaults
    const err = merge({}, DEFAULTS, error);

    state[err.type].push(err);
  },

  REMOVE_ERROR(state, {code, type = 'general'}) {
    var errorToRemove = state[type].find(function(error) {
      return error.code === code;
    });
    state[type].pop(errorToRemove);
  },

  CLEAR_ERROR_TYPE(state, type) {
    if (state[type] && state[type].length) {
      state[type] = [];
    }
  },

  CLEAR_ERRORS(state) {
    state.general = [];
    state.promoCode = [];
    state.giftCard = [];
    state.timeslotPicker = [];
    state.cartChange = [];
    state.changeStore = [];
    state.deliveryAddress = [];
    state.pastPurchases = [];
    state.paymentMethods = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
